// extracted by mini-css-extract-plugin
export default {"question":"Questions_question__cOy5+","qtitle":"Questions_qtitle__gIXAc"};